
const findAttributeByType = ({ attributes, contentType, usedAttributeIds = new Set() }) => {
  if (!attributes?.length) return null

  const enabledAttrs = attributes
    .filter(attr => attr.enabled && !usedAttributeIds.has(attr.attributeId))
    .sort((a, b) => a.ordinal - b.ordinal)

  const typeCompatibility = {
    title: ['title', 'text', 'markdown'],
    text: ['text', 'markdown', 'title'],
    markdown: ['markdown', 'text'],
    number: ['number', 'text']
  }

  const compatibleTypes = typeCompatibility[contentType] || [contentType]
  for (const targetType of compatibleTypes) {
    const match = enabledAttrs.find(attr => attr.type === targetType)
    if (match) return match
  }
  return null
}

export const mapAttributes = ({
  summaryData,
  attributes
}) => {
  if (!summaryData || !attributes) return null
  const usedAttributeIds = new Set()

  let attributeValues = {}
  if (summaryData?.fields) {
    attributeValues = Object.entries(summaryData.fields).reduce((acc, [key, content]) => {
      if (attributes.find(({ accessor }) => accessor === key)) {
        acc[key] = content
        usedAttributeIds.add(key)
      }
      return acc
    }, {})
  } else {
    const attribute = findAttributeByType({ attributes, contentType: 'markdown' }) || findAttributeByType({ attributes, contentType: 'title' })
    if (attribute) {
      attributeValues[attribute.accessor] = summaryData.markdown
      usedAttributeIds.add(attribute.attributeId)
    }
  }

  return {
    attributeValues,
    usedAttributeIds,
    titleAttr: findAttributeByType({ attributes, contentType: 'title' })
  }
}
